export default "__VITE_ASSET__f1ba16fa__"